<template>
  <div ref="generalContainer" ondragstart="return false;" ondrop="return false;">
    <NotificationContainer />

    <router-view v-if="loadedRequisites"></router-view>
    <NoCookiesModal />
  </div>
</template>

<script>
import NotificationContainer from '@/shared/components/notifications/NotificationContainer';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import NoCookiesModal from '@/screens/Login/components/NoCookiesModal';
import postMessage from './helpers/events/postMessage';
import router from './router';
import Auth from './helpers/auth';

const THEME_EDIT_ID = 'theme-edit-style';
const NOT_FOUND_ROUTE = 'notFound';

export default {
  created() {
    const currentRoute = this.$router.currentRoute.name;

    if (currentRoute !== NOT_FOUND_ROUTE) {
      this.fetchProject()
        .then(() => {
          this.adjustProtocol();
          this.setLanguage();

          if (this.project.theme_style) {
            this.loadCustomStyle();
          }
        })
        .catch(() => {
          this.notFound = true;
          this.$router.push('/notFound');
        });

      postMessage.listen(this.receiveData);
    }
  },
  data() {
    return {
      notFound: false,
      postMessages: {
        changeRoute: this.changeRoute,
        authenticate: this.authenticate,
        setStyle: this.updateStyle,
        setImages: this.setImages,
      },
    };
  },
  metaInfo() {
    return {
      title: this.titleProject,
      meta: [
        { vmid: 'og:title', property: 'og:title', content: this.titleProject },
        { vmid: 'og:description', property: 'og:description', content: this.description },
        { vmid: 'description', name: 'description', content: this.description },
      ],
    };
  },
  methods: {
    setLanguage() {
      Vue.config.lang = this.project.language;
      this.$i18n.locale = Vue.config.lang;
    },
    adjustProtocol() {
      const {
        NODE_ENV: enviroment,
        KMB_PROJECTS_DOMAIN: defaultDomain,
      } = process.env;

      if (enviroment === 'development') {
        return;
      }

      const { href } = location;
      const defaultDomainRegex = new RegExp(`(.)*.${defaultDomain}`);

      if (defaultDomainRegex.test(href)) {
        this.adjustDefaultDomainProtocol();
        return;
      }
      this.adjustCustomDomainProtocol();
    },
    adjustDefaultDomainProtocol() {
      const { protocol, href } = location;
      const domain = href.substring(protocol.length);

      if (protocol !== 'https:') {
        location.href = `https:${domain}`;
      }
    },
    adjustCustomDomainProtocol() {
      const { protocol, href } = location;
      const domain = href.substring(protocol.length);
      const { ssl_certificate: hasCertificate } = this.project;

      if (hasCertificate && protocol !== 'https:') {
        location.href = `https:${domain}`;
      }
    },
    receiveData(currentData) {
      const { action, data } = currentData;
      this.postMessages[action](data);
    },
    changeRoute({ name, params }) {
      router.push({ name, params });
    },
    updateStyle(style) {
      const body = document.body;
      let styleTag = body.querySelector(`#${THEME_EDIT_ID}`);

      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.setAttribute('id', THEME_EDIT_ID);
        body.appendChild(styleTag);
      }

      styleTag.innerHTML = style;
    },
    loadCustomStyle() {
      const head = document.head;
      const cdnAddress = this.project.theme_style.cdn_address;
      const styleTagLink = this.normalizeUrl(cdnAddress);

      if (cdnAddress) {
        const styleTag = document.createElement('link');
        styleTag.setAttribute('id', THEME_EDIT_ID);
        styleTag.setAttribute('href', styleTagLink);
        styleTag.setAttribute('rel', 'stylesheet');
        styleTag.setAttribute('type', 'text/css');

        head.appendChild(styleTag);
      }
    },
    normalizeUrl(url) {
      const protocolPattern = /https?:\/\//i;
      return protocolPattern.test(url) ? url : `//${url}`;
    },
    setImages(images) {
      this.setImagesOnState(images);
    },
    authenticate(authToken) {
      if (!Auth.token.has()) {
        Auth.token.set(authToken);
      }
    },
    ...mapActions({
      fetchProject: 'app/fetchProject',
      setImagesOnState: 'app/setImages',
    }),
  },
  computed: {
    loadedRequisites() {
      return this.projectId || this.notFound;
    },
    ...mapGetters({
      projectId: 'app/projectId',
      project: 'app/project',
      titleProject: 'app/title',
      description: 'app/description',
    }),
  },
  components: {
    NoCookiesModal,
    NotificationContainer,
  },
};
</script>

<style lang="scss">
  @import "assets/style/app";
</style>



// WEBPACK FOOTER //
// App.vue?d20e58b0